<template>
  <div>
    <datatable
      @create="createEducation"
      @delete="deleteEducation"
      title="Applicant Educations"
      @edit_click="editClick"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'applicant-educations',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'education_institution',
          value: 'education_institution.name'
        },
        {
          name: 'education_degree',
          value: 'education_degree.name'
        },
        {
          name: 'education_course',
          value: 'education_course.name'
        },
        {
          name: 'grade',
          value: 'grade'
        },
        {
          name: 'with_honors',
          value: 'with_honors'
        },
        {
          name: 'year_start',
          value: 'year_start'
        },
        {
          name: 'month_start',
          value: 'month_start'
        },
        {
          name: 'year_end',
          value: 'year_end'
        },
        {
          name: 'month_end',
          value: 'month_end'
        }
      ],
      data: [],
      operations: [],
      applicant_id: this.$route.query.applicant_id
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils
        .getApplicantEducations({
          current_applicant_id: this.applicant_id
        })
        .then(response => {
          this.data = response
        })
    },
    deleteEducation (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + delete_data.education_institution.name,
        item_name: delete_data.education_institution.name,
        method: 'deleteApplicantEducation',
        method_params: { id: delete_data.id, current_applicant_id: this.applicant_id }
      })
    },
    createEducation () {
      this.create({ designator: 'applicant-educations-form-modal', component_name: 'ApplicantEducationsForm', is_create: true, applicant_id: this.applicant_id, modal_title: 'Create new Education' })
    },
    editClick (data) {
      this.create({ designator: 'applicant-educations-form-modal', component_name: 'ApplicantEducationsForm', data, applicant_id: this.applicant_id, modal_title: data.education_institution.name })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
